import script from "./DeleteHouseholdModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeleteHouseholdModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__